import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  // Use BehaviorSubject to store data and make it observable
  private workPackageItemsSubject = new BehaviorSubject<any[]>([]);
  private packageNameSubject = new BehaviorSubject<string>('');
  private workPackageStandardIdSubject = new BehaviorSubject<string>('');

  // Set data functions that update the subjects
  setData(key: string, value: any) {
    if (key === 'work_package_items') {
      this.workPackageItemsSubject.next(value);
    } else if (key === 'package_name') {
      this.packageNameSubject.next(value);
    } else if (key === 'work_package_standard_id') {
      this.workPackageStandardIdSubject.next(value);
    }
  }

  // Get data functions to return observables for subscription
  getWorkPackageItems() {
    return this.workPackageItemsSubject.asObservable();
  }
  getPackageName() {
    return this.packageNameSubject.asObservable();
  }
  getWorkPackageStandardId() {
    return this.workPackageStandardIdSubject.asObservable();
  }

  // Optional: Get the latest value synchronously (if needed)
  getData(key: string): any {
    if (key === 'work_package_items') {
      return this.workPackageItemsSubject.getValue();
    } else if (key === 'package_name') {
      return this.packageNameSubject.getValue();
    } else if (key === 'work_package_standard_id') {
      return this.workPackageStandardIdSubject.getValue();
    }
  }
}

// Share data in simple form not in real time
// import { Injectable } from '@angular/core';
// import { BehaviorSubject, Observable } from 'rxjs';

// @Injectable({ providedIn: 'root' })
// export class DataService {
//   private data: any = {};

//   setData(key: string, value: any) {
//     this.data[key] = value;
//   }

//   getData(key: string): any {
//     return this.data[key];
//   }

//   saveDataToApi(): Observable<any> {
//     return this.http.post('api/save', this.data);
//   }
// }
